import { Contact } from "@/entities/contact";

export const getChatName = (contact: Contact | undefined): string => {
  if (!contact) return "Новый чат";

  if (contact) {
    const { firstName, lastName, user } = contact;
    if (firstName || lastName) {
      return `${firstName ?? ""} ${lastName ?? ""}`.trim();
    }

    if (user.firstName || user.lastName) {
      return `${user.firstName ?? ""} ${user.lastName ?? ""}`.trim();
    }
  }

  return "Чат без собеседников";
};

export const getContactName = (contact: Contact | undefined): string => {
  if (!contact) return "";

  if (contact) {
    const { firstName, user } = contact;
    if (firstName) {
      return firstName;
    }

    if (user.firstName) {
      return user.firstName;
    }
  }

  return "";
};
